import { parseEnhanceImageError } from "utils/parse-enhance-image-error.util";

import { emptySplitApi } from "./empty-split-api";
import { AiVisualization, AiVisualizationRequestBody } from "./types/ai.type";

export const aiApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiVisualization: builder.query<
      AiVisualization,
      AiVisualizationRequestBody
    >({
      query: (body) => ({
        url: `/ai/visualization/ask/`,
        method: "POST",
        body
      })
    }),
    enhanceLogo: builder.mutation<Blob, { formData: FormData }>({
      query: ({ formData }) => ({
        url: "/ai/logo/enhance/",
        method: "POST",
        body: formData,
        timeout: 120_000,
        // Returns the message on failure rather than throwing — RTK's validateStatus
        // then yields { error: { status, data: message } }. See the util's docstring.
        responseHandler: async (response) =>
          response.ok
            ? response.blob()
            : parseEnhanceImageError(response, "Logo optimization failed"),
        cache: "no-cache"
      })
    })
  })
});

export const {
  useGetAiVisualizationQuery,
  useLazyGetAiVisualizationQuery,
  useEnhanceLogoMutation
} = aiApi;
